<template>
  <div class="col-12 bg-white rounded shadow border p-2">
    <h4 class="d-inline mx-1">فرم درس</h4>
    <b-button pill v-b-modal.connect-form-modal class="d-inline">انتخاب فرم</b-button>
    <hr>

    <b-modal id="connect-form-modal" hide-footer>
      <div class="text-right" dir="rtl">

        <form @submit.prevent="searchForm" class="form-inline ">
          <div class="form-group mx-sm-3 mb-2">
            <input type="text" v-model="searchFormWords" class="form-control" id="connect-form-search">
          </div>
          <button type="submit" class="btn btn-primary mb-2">جست جو</button>
        </form>

        <table class="table text-center table-bordered invoice-table table-responsive-md table-responsive-sm">
          <thead>
          <tr>
            <th scope="col">شناسه</th>
            <th scope="col">نام فرم</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in forms">
            <th scope="row">{{ item.id }}</th>
            <td>{{ item.name }}</td>
            <td>
              <span @click="setItemForm(item)" class="btn btn-primary btn-rounded">انتخاب</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <div class="" v-if="Object.keys(itemForm).length > 0">
      <div class="btn btn-primary rounded-pill" @click="deleteItem">
        {{ itemForm['form'].name }}
        <b-icon-trash class="mx-1"/>
      </div>

    </div>

  </div>
</template>


<script>
import {mapGetters} from "vuex";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "ConnectFormToLesson",
  props: {
    formId: {},
    item_type: {},
  },
  computed: {
    ...mapGetters({
      forms: "Form/getForms"
    })
  },
  data() {
    return {
      itemForm: {},
      searchFormWords: ''
    }
  },
  methods: {
    async loadData() {
      let form = {
        item_type: this.item_type,
        item_id: this.formId,
      }

      let req = await this.$store.dispatch('Form/getItemForm', form)
      let data = req.data.data;
      if (data.length == 0) {
        this.itemForm = []
        return false
      }
      this.itemForm = data
    },
    searchForm() {
      this.$store.commit('Form/setFilters', {key: 'search', value: this.searchFormWords})
      this.$store.dispatch('Form/getForms')
    },
    setItemForm(item) {
      let form = {
        'form': item.id,
        'item_id': this.formId,
        'item_type': this.item_type,
      }

      this.$store.dispatch('Form/connectFormToAnyItem', form)
          .then(res => {
            toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
            this.loadData()
          })

    },
    deleteItem() {
      this.$store.dispatch('Meta/destroyMeta', this.itemForm['meta']).then(res => {
        this.loadData()
      })
    }
  },
  mounted() {
    this.$store.dispatch('Form/getForms')
  },
  watch: {
    formId: {
      handler(newValue, oldValue) {
        if (this.formId != null) {
          this.loadData()
        }
      }
    }
  }
}
</script>


<style scoped>

</style>